var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8503 21.2529C17.4505 22.9768 15.866 24.2444 14.0032 24.2022C12.2011 24.1613 10.7161 22.9076 10.3321 21.2503",
    fill: "#D1D4D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8996 20.3403L11.0708 21.0791C11.377 22.4005 12.5664 23.4111 14.0204 23.444C15.524 23.4781 16.7929 22.4556 17.1116 21.0816L17.2829 20.3428L18.7603 20.6855L18.589 21.4242C18.108 23.498 16.208 25.0107 13.986 24.9603C11.8359 24.9116 10.0551 23.4146 9.5933 21.4214L9.42212 20.6827L10.8996 20.3403Z",
    fill: "#D1D4D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6732 4.67323C9.36348 4.84718 5.92162 8.46731 5.92162 12.9085L5.92113 18.3295L4.56424 20.8723C4.24028 21.479 4.67064 22.2183 5.34774 22.2183H22.6513L22.7833 22.2087C23.3822 22.1204 23.737 21.4391 23.4351 20.8729L22.077 18.3265L22.0784 12.9085C22.0784 8.35571 18.4613 4.66669 13.998 4.66669L13.6732 4.67323Z",
    fill: "#DCDFE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_notification_plus",
    d: "M24.3883 10.5H25.7649V8.22033H28.0001V6.95979H25.7649V4.66669H24.3883V6.95979H22.1667V8.22033H24.3883V10.5Z",
    fill: "#D1D4D7"
  })));
}
export default SvgNotificationIcon;